module.exports = __webpack_public_path__ + "static/media/scroll-4.4ed471ed.png";